import React, { useEffect, useState } from "react";

import * as Material from "@mui/material";

import api from "@helpers/api";
import Parser from '@helpers/parser';
import { Input } from "@fragments";

import './styles.scss'


export default function AvailabilityInPlan({
  onChange = () => { },
  initialValues,
  community,
  className = "",
}) {
  const [loading, setLoading] = useState(true)
  const [value, setValue] = useState(initialValues);
  const [plans, setPlans] = useState([])

  useEffect(() => {
    setValue(initialValues);
  }, [initialValues]);

  useEffect(() => {
    if (loading) handleLoadPlans()
  }, [loading])

  async function handleLoadPlans() {
    try {
      const { data } = await api.get(`/community/${community}/plan?include_deleted=true`)
      setPlans([...data])
    } catch (e) {
      console.log(e)
    }

    setLoading(false)
  }

  const isPublic = !value || (Array.isArray(value) && value.includes("all"));
  const mode = isPublic ? "all" : "specific";

  function handleModeChange(newMode) {
    if (newMode === "all") {
      const newVal = null;
      setValue(newVal);
      onChange(newVal);
    } else {
      // Switch directly to empty array if coming from public, or keep current if valid
      let newVal = [];
      if (Array.isArray(value) && value?.length > 0) {
        newVal = value;
      }
      setValue(newVal);
      onChange(newVal);
    }
  }

  function handlePlansChange(newPlans) {
    setValue(newPlans);
    onChange(newPlans);
  }

  if (loading) return <Material.CircularProgress
    style={{
      margin: "0 auto",
      display: "block"
    }}
    size={20}
    className="loader-plans"
  />

  const planOptions = plans.sort((a, b) => {
    // Planos não deletados (null/undefined) aparecem primeiro
    if (!a.timestamps.deleted && b.timestamps.deleted) return -1;
    if (a.timestamps.deleted && !b.timestamps.deleted) return 1;
    return 0;
  }).map(plan => {
    const priceDescription = plan.price ? `R$ ${Parser.price.brl(plan.price)}, ${Parser.interval.noun(plan.interval).toLowerCase()}` : 'Gratuito';
    return {
      label: `${plan.timestamps.deleted ? '(Deletado) ' : ''}${plan.label}, ${priceDescription}`,
      value: plan.id
    }
  });


  const allPlansSelected = plans.length > 0 && Array.isArray(value) && value.length === plans.length;

  function handleToggleAll(e) {
    if (e) e.stopPropagation();
    const allPlanIds = plans.map(p => p.id);
    if (allPlansSelected) {
      handlePlansChange([]);
    } else {
      handlePlansChange(allPlanIds);
    }
  }

  return (
    <div className={"availability-selects " + className}>
      <Input.Choices
        value={mode}
        onInput={handleModeChange}
        options={[
          {
            label: "Disponível publicamente",
            value: "all",
            description: "Qualquer pessoa poderá assistir a este conteúdo"
          },
          {
            label: "Apenas para assinantes",
            value: "specific",
            description: "Apenas assinantes dos planos selecionados terão acesso"
          }
        ]}
      />

      {mode === "specific" && (
        <div className="mt-2 pl-2 border-left-surface-7" style={{ marginLeft: '8px' }}>
          <Input.SelectOptions
            label="Selecione os planos"
            options={planOptions}
            value={value || []}
            onInput={handlePlansChange}
            collapseInAmount={4}
            end={
              <div
                onClick={handleToggleAll}
                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', opacity: 0.7 }}
                title={allPlansSelected ? "Desmarcar todos" : "Marcar todos"}
              >
                <Material.Checkbox
                  checked={allPlansSelected}
                  size="small"
                  color="secondary"
                  style={{ padding: 4 }}
                  // prevent default onChange to avoid bubbles or issues
                  onChange={() => { }}
                />
                <span style={{ fontSize: '0.85em', userSelect: 'none', whiteSpace: 'nowrap', transform: 'translateY(1px)' }}>Qualquer plano</span>
              </div>
            }
          />
        </div>
      )}
    </div>)
}
